import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  html {
    font-family: Open-Sans, Helvetica, Sans-Serif;
    background-color: ${({ theme }) => theme.colors.background};
  }
  p {
    line-height: 1.6;
  }
  #content {
    color:#424244;
    line-height: 1.6;
    font-size: 16px;
  }
  #content ul, #content ol {
    line-height: 1.6;
    margin-left: 18px;
  }
  #content p, #content ul, #content img {
    margin-bottom: 1rem;
  }
`;

export default GlobalStyles;
